export default __webpack_public_path__ + "static/media/iconRecentesAlterado.f42269a8.svg";